import React, {useState, useEffect, useCallback, useMemo} from "react";

// ------------ Lib ------------------
import _ from "lodash";

// ------------ Components ------------
import Modal from 'react-bootstrap/Modal'
import {
    Row,
    Col,
    Button,
    Form,
    ListGroup,
    Table,
    Toast,
    Pagination,
    InputGroup,
    Image,
    FormControl,
    Spinner
} from "react-bootstrap";
import Loader from "../Loader/Loader";
import EditIcon from '@material-ui/icons/Edit';
import { Close, Delete, Description } from "@material-ui/icons";
import DescriptionIcon from '@material-ui/icons/Description';
import { Tab, Tabs } from "react-bootstrap";
import { Info, Photo } from "@material-ui/icons";

// -------------- APIs ---------------
import API from "../../network/dashboardAPI";

// -------------- Style --------------
import styled from "styled-components";
import "react-datetime/css/react-datetime.css";
import UploadService from "../../services/FileUploadService";
import history from "../../services/history";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TableBody,
	TableCell,
	TablePagination,
	TableRow,
	Button as MButton,
	Paper,
	TableContainer,
	TableHead,
	Table as MTable,
    LinearProgress,
    makeStyles,
    colors,
    TextField,
    AppBar,
    Toolbar,
    IconButton,
} from "@material-ui/core";

const HelpPageWrapper = styled.div`
  position: relative;
  
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

const labelStyle = {
    lineHeight: "2rem",
    minWidth: "140px"
}

const logo = {
    height: "50Px",
    width: "50Px"
}

const appPort = window.location.port.toString();
const appProtocol = window.location.protocol.toString();
const appHost = window.location.hostname.toString();
const appUrl = `${appProtocol}//${appHost}:${appPort}`

const useStyles = makeStyles({
    topScrollPaper: {
      alignItems: 'flex-start',
    },
    topPaperScrollBody: {
      verticalAlign: 'top',
    },
    toolbar: {
        padding: 0
    }
  });

const TypesCatsManagement = (props) => {
    /*
    *   Reference
    * */
    const _imageInputFile = React.useRef(null);
    const classes = useStyles();


    /*
    *   =================== States ==========================
    * */
    const [isRequesting, setIsRequesting] = useState(false);
    const [isRequestingUpsert, setIsRequestingUpsert] = useState(false);
    const [isUploadingImage, setIsUploadingImage] = useState(false);

    // table states
    const [dataList, setDataList] = useState([]);

    // available cats for type (add to type)
    const [catsList, setCatsList] = useState([]);
    const [catsListError, setCatsListError] = useState('');
    const [selectedCats, setSelectedCats] = useState('');

    // deleted cats in type 
    const [deleteCat, setDeleteCat] = useState('');

    // filter states
    const [selectedStatus, setSelectedStatus] = useState(1);

    // pagination states
    const [next, setNext] = useState(0);
    const [limit, setLimit] = useState(10);
    const [prev, setPrev] = useState(0);
    const [pager, setPager] = useState(1);
    const [dataCount, setDataCount] = useState(0);

    // modal states
    const [isShowModal, setIsShowModal] = useState(false);
    const [isShowImageModal, setIsShowImageModal] = useState(false);
    const [imageLinkToView, setImageLinkToView] = useState("");

    // form states
    const [validated, setValidated] = useState(false);
    const [dataToUpdate, setDataToUpdate] = useState({});
    // const [webLink, setWebLink] = useState("");
    const [dataId, setDataId] = useState("");
    const [dataNumber, setDataNumber] = useState("");
    const [isActive, setIsActive] =useState(false)
    const [formType, setFormType] = useState("ADD");

    // Form validation
    const [formError, setFormError] = useState({
        name: false,
        typeRefId: false,
        imageLink: false,
        // webLink: false,
        dataNumber: false
    });
    // const [webLinkFormatError, setWebLinkFormatError] = useState(false);

    // toast states
    const [toastBgColor, setToastBgColor] = useState('bg-success');
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("Delete successful");

    // Taps states
    const [type, setType] = useState('');

    // confirm
    const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    const [dataToUpdateStatus, setDataToUpdateStatus] = useState({});
    const [isRequestingUpdateStatus, setIsRequestingUpdateStatus] = useState(false);

    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [subCategories, setSubCategories] = useState([]);
    const [subCategoryTotal, setSubCategoryTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogUpdateOpen, setDialogUpdateOpen] = useState(false);
    const [category, setCategory] = useState(null);
    const [selectedSubcategory, setSelectedSubcategory] = useState({});

    const isValidPositionNumber = useMemo(() => {
        const regex = /^-?\d*\.?\d+$/;
        return regex.test(selectedSubcategory?.order);
    }, [selectedSubcategory]);

    const handleToggleDialog = (category = null) => {
        setDialogOpen((prev) => !prev);
        setCategory(category);
    }

    const handleToggleDialogUpdate = (item = {}) => {
        setDialogUpdateOpen((prev) => !prev);
        setSelectedSubcategory(item);
    } 

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowPerPage = (event) => { 
        setPage(0);
        setPerPage(parseInt(event.target.value, 10));
    }

    const handleChangePosition = (event) => {
        if(selectedSubcategory) {
            setSelectedSubcategory((value) => ({ ...value, order: event.target.value }))
        }
    }

    const handleGetSubCatsType = useCallback((catId, page, limit) => {
        if(!catId) return;
        setLoading(true);
        API.getSubCatsType(catId, page + 1, limit)
            .then((response) => response.json())
            .then((response) => {
                if(response.success) {
                    setSubCategories(response.data.list)
                    setSubCategoryTotal(response.data.total)
                }
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            })
    }, []);

    const handleUpdateSubCatTypeSequence = () => {
        if(!isValidPositionNumber) return;
        const body = {
            catId: category?.cat_id,
            subCatId: selectedSubcategory?.sub_cat_id,
            order: selectedSubcategory?.order
        }

        setSubmitting(true);
        API.updateSubCatsTypeSequence(body)
            .then((response) => response.json())
            .then((response) => {
                if(response.success) {
                    setDialogUpdateOpen(false);
                    handleGetSubCatsType(category?.cat_id, page, perPage);
                }
                setSubmitting(false);
            })
            .catch((err) => {
                setSubmitting(false);
                console.error(err);
            })
    }

    useEffect(() => {
        handleGetSubCatsType(category?.cat_id, page, perPage);
    }, [handleGetSubCatsType, perPage, page, category]);

    /*
    *   =================== Methods =========================
    * */
    const getTypesCatsList = async ($next) => {
        setIsRequesting(true);
        let params = {type_id: props.type_id ,next: $next, limit}
        let query = {
            isDeleted: 0,
            // type,
            isActive: selectedStatus
        }

        if (selectedStatus === 1 || selectedStatus === 0) {
            query.isActive = selectedStatus
        }

        await API.getTypesCats(params, query)
            .then(res => res.json())
            .then(res => {
                if (res.success === true && !_.isEmpty(res.data)) {
                    setType(res.data.type);
                    setDataList(res.data.list);
                    setDataCount(res.data.total);

                    if (res.data.next) {
                        setNext(res.data.next);
                    } else if (res.data.list.length) {
                        setNext($next > 0?next + res.data.list.length: res.data.list.length);
                    } else {
                        setNext(0);
                    }

                    setIsRequesting(false);
                } else {
                    setIsRequesting(false);
                }
            });
    }

    const getCatLists = async () => {
        await API.getCatsForTypes()
            .then(res => res.json())
            .then(res => {
                if(res.success === true) {
                    setCatsList(res.data.cats);
                }else{
                    setCatsListError('Error')
                }
            })
    }
    const updateTypesCats = async () => {
        setIsRequestingUpsert(true);

        let params = {
            id: dataId
        }

        let body = {
            // image_link: imageLink,
            is_active: dataToUpdate.is_active,
            cat_id: dataToUpdate.cat_id,
            type_id: dataToUpdate.type_id,
            // type,
            // name,
            // typeRefId,
            order: dataNumber,
            // web_link: webLink,
            // app_link: dataToUpdate.app_link,
            store_id: dataToUpdate.store_id
        }

        await API.updateTypesCats(params, body)
            .then(res => res.json())
            .then(res => {
                if (res.success === true && !_.isEmpty(res.data)) {
                    // let updatedSlideIndex = dataList.findIndex(x => x.id === dataId);
                    // if(updatedSlideIndex > -1){
                    //     dataList[updatedSlideIndex] = _.clone(res.data);
                    // }
                    handleShowToast("SUCCESS");
                    setIsRequestingUpsert(false);
                    getTypesCatsList(0);
                    handleCloseModal();
                } else {
                    handleShowToast("ERROR");
                    setIsRequestingUpsert(false);
                }
            });

    }

    const createTypesCats = async () => {
        setIsRequestingUpsert(true);

        let params = {
            type_id: props.type_id
        }

        let body = {
            order: 1,
            type_id: props.type_id,
            cat_id: selectedCats,
            is_active: 1,
            is_deleted: 0,
        }

        await API.createTypesCats(params, body)
            .then((res) => res.json())
            .then((res) => {
                if(res.success){
                    handleShowToast("SUCCESS");
                    getTypesCatsList(0);
                }else{
                    handleShowToast("ERROR");
                }

                // reset paginate
                resetPagination();

                setIsRequestingUpsert(false);
                handleCloseModal();
            })
    }

    const deleteTypesCats = async () => {
        setIsRequestingUpsert(true);
        let params = {
            id: deleteCat
        }
        await API.deleteTypesCats(params)
        .then(res => res.json())
        .then(res => {
            if (res.success === true) {
                handleShowToast("SUCCESS");
                setIsRequestingUpsert(false);
                getTypesCatsList(0);
                handleCloseConfirmModal()
            } else {
                handleShowToast("ERROR");
                setIsRequestingUpsert(false);
                handleCloseConfirmModal()
            }
        });
    }

    const setFormData = (type) => {
        setDataToUpdate(type);
        // setName(type.name);
        // setTypeRefId(type.typeRefId);
        // setImageLink(type.image_link);
        setDataId(type.id);
        // // setWebLink(type.web_link);
        setDataNumber(type.order);
        setIsActive(type.is_active);
    }

    const resetFormData = () => {
        setDataToUpdate({});
        // setName("");
        // setTypeRefId("");
        // setImageLink("");
        setDataId("");
        // // setWebLink("");
        setDataNumber("");
        // setIsUploadingImage(false);
        setIsActive(false);
    }

    const resetPagination = () => {
        setPager(1);
        setPrev(0);
    }

    /*
    *   ==================== Compute Data ========================
    * */

    useEffect(() => {
        getTypesCatsList(0);
    }, [selectedStatus]);


    /*
    *  ===================== Event handlers ======================
    * */

    const handleOpenModal = (formType, data) => {
        if(formType === "UPDATE"){
            setFormData(data);
        }else{
            getCatLists();
        }


        setFormType(formType);
        setIsShowModal(true);
    }

    // modal event
    const handleCloseModal = () => {
        setIsShowModal(false);
        resetFormData();
        resetFormError();
        setCatsListError('Error');
        setCatsList([])
    }

    const resetFormError = () => {
        setFormError({
            name: false,
            typeRefId: false,
            imageLink: false,
            // webLink: false,
            dataNumber: false
        })

        // setWebLinkFormatError(false);
    }

    // const handleNameChange = (e) => {
    //     setName(e.target.value);
    // }

    // const handleTypeRefId = (e) => {
    //     setTypeRefId(e.target.value);
    // }

    const handleChangedataNumber = (e) => {
        setDataNumber(e.target.value);
    }

    const handleUpsertSlider = async () => {
        if(checkFormValidate()){
            if(dataId){
                await updateTypesCats();
            }else if(selectedCats){
                await createTypesCats();
            }
        }
    }

    const checkFormValidate =() => {
        let tmpFormError = {
            catId: false,
            dataNumber: false
        }

        if(!dataNumber && formType === "UPDATE") tmpFormError.dataNumber = true;

        setFormError(tmpFormError);
        return Object.values(tmpFormError).every(el => el === false);
    }

    // const checkValidateWebLink = () => {
    //     let linkExpressValidate = webLink.includes(`${appUrl}/express`);
    //     let linkServer = webLink.includes(`${appUrl}`);
    //     if(type === 0){
    //         setWebLinkFormatError(linkExpressValidate);
    //         return !linkExpressValidate;
    //     }else{
    //         setWebLinkFormatError(linkServer?!linkExpressValidate: false);
    //         return linkServer?linkExpressValidate: true ;
    //     }
    // }

    // toast event
    const handleShowToast = (type) => {
        setShowToast(true);

        if (type === "SUCCESS") {
            setToastBgColor("bg-success");
            setToastMessage("Operation successful.");
        } else if (type === "ERROR") {
            setToastBgColor("bg-error");
            setToastMessage("Operation error.");
        }
    }

    // pagination handlers
    const handlePaginNext = () => {
        const {next, prev} = updatePaginationProps("NEXT");
        getTypesCatsList(prev);
    };

    const handlePaginPrev = () => {
        const {pager, next, prev} = updatePaginationProps("PREV");
        getTypesCatsList(prev);
    };

    const updatePaginationProps = (type) => {
        let tmpPager = pager + 1;
        if (type === "PREV") {
            tmpPager = pager - 1;
        }

        const tmpNext = limit * tmpPager;
        const tmpPrev = limit * tmpPager - limit;

        setPager(tmpPager);
        setPrev(tmpPrev);

        return {pager: tmpPager, next: tmpNext, prev: tmpPrev};
    };

    // const handleFileChange = async (action) => {
    //     try {
    //         setIsUploadingImage(true);
    //         let formData = null;

    //         if(_imageInputFile.current !== null && action === "home") {
    //             formData = new FormData();
    //             formData.append("image", _imageInputFile.current.files[0]);

    //             await UploadService.uploadImageFromDashboard(formData).then(response => {
    //                 if(response.data.success && response.data.data.length) {
    //                     handleShowToast("SUCCESS");
    //                     setImageLink(response.data.data[0].url);
    //                 }
    //                 setIsUploadingImage(false);
    //             });
    //         }
    //     } catch(e) {
    //         console.log("Debug: ", e);
    //         handleShowToast("ERROR")
    //         setIsUploadingImage(false);
    //     }
    // };


    const handleShowImageModal = (url) => {
        setImageLinkToView(url)
        setIsShowImageModal(true);
    }

    const handleCloseImageModal = () => {
        setImageLinkToView("");
        setIsShowImageModal(false);
    }

    const handleCloseConfirmModal = () => {
        setIsShowConfirmModal(false);
        setIsRequestingUpdateStatus(false);
        setDataToUpdateStatus({});
        setDeleteCat('');
    }

    const handleOpenConfirmModal = (oparation,data) => {
        setIsShowConfirmModal(true);
        if(oparation==="STATUS"){
            setDataToUpdateStatus(data);
        }else if(oparation==="DELETE")(
            setDeleteCat(data.id)
        )
        
    }

    const handleSubmitDisActive = async () => {
        setIsRequestingUpdateStatus(true);

        let params = {
            id: dataToUpdateStatus.id,
        }

        let body = {
            is_active: dataToUpdateStatus.is_active === 1? 0: 1,
            order: dataToUpdateStatus.order,
            cat_id: dataToUpdateStatus.cat_id,
            type_id: dataToUpdateStatus.type_id
        }

        await API.updateTypesCats(params, body)
            .then(res => res.json())
            .then(res => {
                if (res.success === true && !_.isEmpty(res.data)) {
                    handleShowToast("SUCCESS");
                    handleCloseConfirmModal();
                    getTypesCatsList(0);

                    // reset paginate
                    resetPagination();
                } else {
                    handleShowToast("ERROR");
                    handleCloseConfirmModal();
                }
            });

    }

    const handleChangeStatusFilter = (e) => {
        // reset pagination
        resetPagination();

        setSelectedStatus(e.target.value);
    }

    const handleSelectCatsToAdd = (value) => {
        setSelectedCats(value)
    }

    /*
    *   ==================== Functional Components ================
    * */

    const tableContent = (
        dataList.length ? dataList.map((cat, index) => (
                <tr key={index}>
                    <td className="text-center">{cat.order}</td>
                    <td className="text-center" onClick= {()=>handleShowImageModal(cat.list_categories[0].image)}>
                        <img src={cat.list_categories[0].image} alt="img" style={logo}/>
                    </td>
                    <td>{cat.list_categories[0].name}</td>
                    {/* <td>{type.type_ref_id}</td> */}
                    <td className="text-center">
                        <Button variant={cat.is_active === 1? "success": "danger"}
                                style={{
                                    width: "12vh",
                                    border: "none",
                                    outline: "none",
                                    boxShadow: "none"
                                }}
                                onClick={() => handleOpenConfirmModal('STATUS',cat)}
                        >
                            {cat.is_active === 1? "Active": "Inactive"}
                        </Button>
                    </td>
                    <td className="text-center">
                        <Button variant="info" onClick={() => handleOpenModal("UPDATE", cat)}>
                            <EditIcon></EditIcon>
                        </Button>
                        <Button className="ml-2" variant="danger" onClick={() => handleOpenConfirmModal("DELETE",cat)}>
                            <Delete></Delete>
                        </Button>
                        <Button className="ml-2" onClick={() => handleToggleDialog(cat.list_categories[0])}>
                            <Description />
                        </Button>
                    </td>
                </tr>
            )) :
            <tr>
                <td colSpan={5} className="text-center">No data</td>
            </tr>
    )

    let pageItems = [
        <Pagination.Item disabled={next <= limit} key={0} onClick={handlePaginPrev}>
            Prev
        </Pagination.Item>,
        <Form.Group key={1} controlId="formGridPagination">
            <InputGroup>
                <InputGroup.Prepend>
                    <InputGroup.Text>{`${next} / ${dataCount}`}</InputGroup.Text>
                </InputGroup.Prepend>
            </InputGroup>
        </Form.Group>,
        <Pagination.Item
            disabled={next === dataCount}
            key={2}
            onClick={handlePaginNext}
        >
            Next
        </Pagination.Item>,
    ];
    const PaginationBasic = () => (
        <div className="d-flex justify-content-center">
            <Pagination>{pageItems}</Pagination>
        </div>
    );


    return (
        <HelpPageWrapper>
            <div className="d-flex justify-content-between mb-3">
                { type.name && (
                    <Title>
                        Type: {type.name}
                    </Title>                    
                )}

                
                <Button variant="success" disabled={isRequesting || isRequestingUpsert} onClick={() => {
                    history.push(`/admin/menu`)
                    window.location.reload()
                }}>
                    Back
                </Button>
            </div>
            <SettingsFormContent>
                <div>
                        <Row className="mb-2">
                            <Col sm={9}>
                                <Button variant="success" disabled={isRequesting || isRequestingUpsert} onClick={() => handleOpenModal("ADD", null)}>
                                    Add Category
                                </Button>
                            </Col>

                            <Col sm={3} className="d-flex justify-content-end">
                                <Form.Label style={labelStyle}>Filter status: </Form.Label>&nbsp;&nbsp;
                                <Form.Control
                                    as="select"
                                    disabled={isRequesting || isRequestingUpsert}
                                    onChange={(e) => handleChangeStatusFilter(e)}
                                    value={selectedStatus}
                                >
                                    <option value={""}>All status</option>
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                </Form.Control>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                {isRequesting ?
                                    <div style={{position: "fixed", left: "55%", top: "35%"}}><Loader color="#9cc54b" h="100"/>
                                    </div> :
                                    [
                                        <Table striped bordered hover key={1}>
                                            <thead>
                                            <tr>
                                                <th className="text-center">Position</th>
                                                <th className="text-center">Image</th>
                                                <th>Name</th>
                                                {/* <th>Description</th> */}
                                                <th className="text-center">Status</th>
                                                <th className="text-center">Actions</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {tableContent}
                                            </tbody>
                                        </Table>,
                                        <PaginationBasic key={2}></PaginationBasic>
                                    ]
                                }
                            </Col>
                        </Row>
                </div>
            </SettingsFormContent>

            {/* Dialog for Sub-category list */}
            <Dialog
                open={dialogOpen}
                onClose={handleToggleDialog}
                fullWidth
                maxWidth="xl"
                scroll="body"
                classes={{
                    scrollPaper: classes.topScrollPaper,
                    paperScrollBody: classes.topPaperScrollBody,
                }}
            >
                <AppBar
                    color="transparent"
                    variant="outlined"
                    style={{ position: "relative" }}
                >
                    <Toolbar classes={{ root: classes.toolbar }}>
                        <DialogTitle style={{ flex: 1 }}>SubCategories of {category?.name}</DialogTitle>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={handleToggleDialog}
                            aria-label="close"
                        >
                            <Close />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers>
                    <TableContent>
                        <Paper>
                            <TableContainer style={{ maxHeight: window.innerHeight - 220 }}>
                                <MTable stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Position</TableCell>
                                            <TableCell align="center">Image</TableCell>
                                            <TableCell align="left">Name</TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody style={{ position: "relative" }}>
                                        {loading && (
                                            <div
                                                style={{
                                                    display: "block",
                                                    position: "absolute",
                                                    inset: 0,
                                                    background: "rgb(166 166 166 / 20%)",
                                                }}
                                            ></div>
                                        )}
                                        {subCategories.length > 0 ? (
                                            subCategories?.map((row) => {
                                                return (
                                                    <TableRow key={row?.sub_cat_id} hover>
                                                        <TableCell align="center">{row?.order}</TableCell>
                                                        <TableCell align="center">
                                                            <img
                                                                src={
                                                                    row?.banner_image ||
                                                                    require("./../../assets/icons/delishop_logo2.svg")
                                                                }
                                                                alt={row?.name}
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = require("./../../assets/icons/delishop_logo2.svg");
                                                                }}
                                                                style={{
                                                                    display: "inline",
                                                                    width: 50,
                                                                    height: "auto",
                                                                    objectFit: "contain",
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="left">{row?.name}</TableCell>
                                                        <TableCell align="center">
                                                            <MButton
                                                                variant="contained"
                                                                color="inherit"
                                                                style={{ background: colors["green"]["600"], color: "#fff", height: "fit-content", }}
                                                                size="small"
                                                                onClick={() => handleToggleDialogUpdate(row)}
                                                            >
                                                                <EditIcon />
                                                            </MButton>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell align="center" colSpan={4}>
                                                    No Data
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </MTable>
                            </TableContainer>
                            <div
                                style={{
                                    display: "block",
                                    width: "100%",
                                    height: "5px",
                                }}
                            >
                                {loading && <LinearProgress variant="query" />}
                            </div>
                            <TablePagination
                                component="div"
                                page={page}
                                rowsPerPage={perPage}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                count={subCategoryTotal}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowPerPage}
                            />
                        </Paper>
                    </TableContent>
                </DialogContent>
            </Dialog>

            {/* Dialog for Update Sub-category Position */}
            <Dialog maxWidth="sm" open={dialogUpdateOpen}>
                <DialogTitle>Update {selectedSubcategory?.name} Position ?</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Position"
                        placeholder="Enter sub-category position"
                        disabled={submitting}
                        value={selectedSubcategory?.order}
                        onChange={handleChangePosition}
                    />
                </DialogContent>
                <DialogActions>
                    <MButton
                        variant="text"
                        color="secondary"
                        className="text-capitalize"
                        disabled={submitting}
                        onClick={handleToggleDialogUpdate}
                    >
                        Cancel
                    </MButton>
                    <MButton
                        variant="text"
                        color="primary"
                        className="text-capitalize"
                        disabled={submitting || !isValidPositionNumber}
                        onClick={handleUpdateSubCatTypeSequence}
                    >
                        Submit
                    </MButton>
                </DialogActions>
            </Dialog>

            <Modal
                show={isShowModal}
                onHide={handleCloseModal}
                aria-labelledby="contained-modal-title-vcenter"
                size="m"
                animation={false}
                centered
            >
                <Form
                    noValidate
                    autoComplete="false"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{formType === "ADD"? "Add Category to Types": "Update Position"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body key="modalBody">
                        <Row>
                            <Col>
                                {
                                    formType === "UPDATE" &&
                                    <Form.Group controlId="formSlider">
                                        <Form.Label>Display number*</Form.Label>
                                        {isActive ? 
                                            (
                                            <FormControl id="slide-number"
                                                        value={dataNumber}
                                                        disabled={isRequestingUpsert}
                                                        aria-describedby="slide-number"
                                                        isInvalid={formError.dataNumber}
                                                        onChange={(e) => handleChangedataNumber(e)}
                                            />
                                            ):(
                                            <FormControl id="slide-number"
                                                value={dataNumber}
                                                disabled
                                                aria-describedby="slide-number"
                                            />
                                            )
                                        }

                                        <Form.Control.Feedback type="invalid">Display number is required.</Form.Control.Feedback>
                                    </Form.Group>
                                }
                                {
                                    formType === "ADD" &&
                                    <Form.Group controlId="formSlider">
                                    <Form.Label>Select Category</Form.Label>
                                    {catsList.length>0 ? 
                                        (
                                            <Form.Control
                                                as="select"
                                                onChange={(e)=>handleSelectCatsToAdd(e.target.value)}
                                                value={selectedCats}
                                            >
                                                <option>Select Catategory</option>
                                                {
                                                    catsList.map(cat => {
                                                        return(
                                                            <option value={cat.cat_id}>{cat.name}</option>
                                                        )
                                                    })

                                                }
                                            </Form.Control>
                                        ):(
                                            <Form.Label>Category is not found</Form.Label>
                                        )
                                    }

                                    <Form.Control.Feedback type="invalid">Display number is required.</Form.Control.Feedback>
                                </Form.Group>
                                }
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button disabled={isRequestingUpsert || isUploadingImage} variant="primary"
                                onClick={() => handleUpsertSlider()}>
                            {
                                isRequestingUpsert?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />:
                                    null
                            }

                            <span className="pl-2 pr-2">
                                {formType === "ADD"? "Add": "Update"}
                            </span>
                        </Button>

                        <Button
                            disabled={isRequestingUpsert}
                            variant="secondary"
                            onClick={handleCloseModal}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/*
                ================ View image modal
            */}

            <Modal show={isShowImageModal} onHide={handleCloseImageModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Image</Modal.Title>
                </Modal.Header>
                <Modal.Body><img alt ="Product" src = {imageLinkToView} style = {{width: "100%", alignItems : "center"}}/></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseImageModal}>
                        Close
                    </Button>
                    {/* <Button variant="danger">
                 Mark out of stock
            </Button> */}
                </Modal.Footer>
            </Modal>

            {/*
                ================ Confirm active / inactive
            */}
            <Modal show={isShowConfirmModal}
                   animation={false}
                   onHide={handleCloseConfirmModal}
                   aria-labelledby="contained-modal-title-vcenter"
                   size="xs"
                   centered
            >
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title className="text-white">Warning</Modal.Title>
                </Modal.Header>
                <Modal.Body key="modalBody" className="text-center">
                    <Form.Label>Do you want to {
                        deleteCat !== '' ?
                            "delete"
                        :dataToUpdateStatus.is_active? "inactive": "active"
                    } this catagory?</Form.Label>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                        <Button variant="danger" disabled={isRequestingUpdateStatus} onClick={deleteCat !== '' ? deleteTypesCats: handleSubmitDisActive}>
                            {
                                isRequestingUpsert?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />:
                                    null
                            }
                            <span className="pl-2 pr-2">Ok</span>
                        </Button>

                    <Button variant="secondary" disabled={isRequestingUpdateStatus} onClick={handleCloseConfirmModal}>Cancel</Button>
                </Modal.Footer>
            </Modal>


            <Toast className={toastBgColor}
                   onClose={() => setShowToast(false)}
                   show={showToast}
                   delay={3000}
                   autohide
                   style={{
                       position: 'fixed',
                       top: 70,
                       right: 35,
                       zIndex: 1041,
                       width: "300px"
                   }}
            >
                <Toast.Header>
                    <strong className="mr-auto m-3">{toastMessage}</strong>
                </Toast.Header>
            </Toast>
        </HelpPageWrapper>

    );
}

// Style


const Title = styled.h4`

`
const ImageLoading = styled.div`
  position: relative;
  
  .hide {display: none;}
  .isLoading {
    position: absolute;
    background-color: rgb(255,255,255,0.4);
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

const SettingsFormContent = styled.div`
  margin-bottom: 50px;

  &:last-child {
    margin-bottom: 0;
  }
  .tabProfile {
    border-bottom: 1px solid #ddd !important;
    justify-content: center;
    margin-bottom: 20px;
  }
`;

const TableContent = styled.div`
	table {
		thead tr th {
            width: initial;
            vertical-align: middle;
            font-weight: 700;
            font-size: 0.95rem;
            background: #efefef;
        }

        tbody tr td {
            vertical-align: middle;
            white-space: nowrap;
            font-size: 0.95rem;
        }
	}

    .MuiDialogContent-dividers {
        padding: 16px;
    }

    .MuiTableContainer-root {
        ::-webkit-scrollbar {
            width: 9px;
            height: 9px;
            border-radius: 3px;
        }
    
        ::-webkit-scrollbar-thumb {
            background: #dee2e6;
            border-radius: 3px;

            &:hover {
                background: #9c9a9a;
            }
        }
    }
`;

export default TypesCatsManagement;
